import type { ReactNode } from 'react'

import { Card, CardHeading, LabeledSwatch } from '@/components/ui'
import { semanticColors } from '@/utils'

interface ChartCardProps {
  title: string
  description: string
  toolbar?: ReactNode
  children: ReactNode
}

export function ChartCard({
  title,
  description,
  toolbar,
  children,
}: ChartCardProps) {
  return (
    <Card className="flex flex-col overflow-hidden">
      <CardHeading
        title={title}
        // Two lines are held open so side-by-side charts start at the same height.
        description={
          <span className="line-clamp-2 block min-h-10">{description}</span>
        }
        actions={toolbar}
      />
      <div className="flex items-center gap-3 px-6 pb-2 text-ink-subtle text-xs">
        <LabeledSwatch
          size="md"
          color={semanticColors.inflow}
          label="Net inflow"
        />
        <LabeledSwatch
          size="md"
          color={semanticColors.outflow}
          label="Net outflow"
        />
      </div>
      <div className="h-[420px] px-6 pb-6">{children}</div>
    </Card>
  )
}
